import script from "./MonthlyHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonthlyHistory.vue?vue&type=script&setup=true&lang=ts"

import "./MonthlyHistory.vue?vue&type=style&index=0&id=248e7f68&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-248e7f68"]])

export default __exports__